import { useState } from "react";
import { scaleOrdinal } from "d3-scale";
import { schemePaired } from "d3-scale-chromatic";

const aquiferValues = [
  "Alluvium",
  "Austin Chalk",
  "Buda",
  "Edwards (BFZ)",
  "Edwards Equivalent",
  "Kemp",
  "Lake Waco",
  "Lower Trinity",
  "Middle Trinity",
  "Ozan",
  "Pecan",
  "Undeclared",
  "Upper Trinity",
];

const primaryUseValues = [
  "Ag/Irrigation",
  "Domestic",
  "Industrial",
  "Livestock/Poultry",
  "Monitoring",
  "Not Used",
  "Other",
  "Public Supply",
  "Testing",
];

const wellStatusValues = [
  "Abandoned",
  "Active",
  "Capped",
  "Inactive",
  "Never Drilled",
  "Plugged",
  "Proposed",
  "Unknown",
];

const wellTypeValues = [
  "exempt",
  "exempt-monitoring",
  "exempt-permitted",
  "monitoring",
  "monitoring-permitted",
  "other",
  "permitted",
];

const managementZonesValues = [
  "Belton Lake",
  "Outside Management Zones",
  "Stillhouse Hollow",
  "Southwest",
  "Eastern",
];

const buildScale = (values) => {
  const scale = scaleOrdinal(schemePaired);
  return values.reduce((acc, val) => {
    acc.push([val]);
    acc.push(scale(val));
    return acc;
  }, []);
};

const layerId = "clearwater-wells-circle";
const styleValues = {
  default: {
    id: "default",
    layerId,
    layerFieldName: "",
    name: "Default",
    paint: {
      "circle-color": [
        "match",
        ["get", "well_status"],
        ["Plugged"],
        "#880000",
        ["Never Drilled"],
        "yellow",
        "#1e8dd2",
      ],
    },
  },
  aquifers: {
    id: "aquifers",
    layerId,
    layerFieldName: "source_aquifer",
    name: "Aquifers",
    paint: {
      "circle-color": [
        "match",
        ["get", "source_aquifer"],
        ...buildScale(aquiferValues),
        "#000000",
      ],
    },
  },
  primaryUses: {
    id: "primaryUses",
    layerId,
    layerFieldName: "primary_use",
    name: "Primary Uses",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "primary_use"],
        ...buildScale(primaryUseValues),
        "#000000",
      ],
    },
  },
  wellStatus: {
    id: "wellStatus",
    layerId,
    layerFieldName: "well_status",
    name: "Well Status",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "well_status"],
        ...buildScale(wellStatusValues),
        "#000000",
      ],
    },
  },
  wellType: {
    id: "wellType",
    layerId,
    layerFieldName: "well_type",
    name: "Well Type",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "well_type"],
        ...buildScale(wellTypeValues),
        "#000000",
      ],
    },
  },
  managementZones: {
    id: "managementZones",
    layerId,
    layerFieldName: "management_zone",
    name: "Management Zones",
    options: [],
    type: "multi-select",
    value: [],
    paint: {
      "circle-color": [
        "match",
        ["get", "management_zone"],
        ...buildScale(managementZonesValues),
        "#000000",
      ],
    },
  },
};

const useLayerStyles = ({ onLayerStyleChange }) => {
  const [activeStyle, setActiveStyle] = useState(styleValues.default);
  const styleOptions = Object.entries(styleValues).map(([key, value]) => ({
    display: value.name,
    value: key,
  }));

  const handleActiveStyle = (name) => {
    setActiveStyle(styleValues[name]);
    onLayerStyleChange(styleValues[name]);
  };

  return {
    activeStyle,
    handleActiveStyle,
    styleOptions,
    styleValues,
  };
};

export default useLayerStyles;
